import { Breadcrumbs } from "./Breadcrumbs";
import { SectionLabel } from "./SectionLabel";

export const PageHero = ({ label, title, intro, crumbs = [], variant = "light" }) => {
  const dark = variant === "dark";
  return (
    <section
      className={`relative overflow-hidden border-b ${
        dark ? "border-white/10 bg-brand-ink text-white" : "border-brand-line bg-white text-brand-ink"
      }`}
    >
      <div className={`absolute inset-0 ${dark ? "grid-paper-dark opacity-40" : "grid-paper opacity-60"}`} />
      <div className="relative mx-auto max-w-7xl px-5 py-14 lg:px-8 lg:py-20">
        {crumbs.length > 0 && (
          <div className={dark ? "[&_a]:text-white/60 [&_a:hover]:text-white [&_span]:text-white/80 [&_svg]:text-white/40" : ""}>
            <Breadcrumbs items={crumbs} />
          </div>
        )}
        {label && <div className="mt-6"><SectionLabel light={dark}>{label}</SectionLabel></div>}
        <h1 className="max-w-4xl font-heading text-4xl font-black tracking-tight sm:text-5xl">
          {title}
        </h1>
        {intro && (
          <p className={`mt-5 max-w-2xl text-lg leading-relaxed ${dark ? "text-white/70" : "text-brand-muted"}`}>
            {intro}
          </p>
        )}
      </div>
    </section>
  );
};
